export default (state = {}, action) => {
  switch (action.type) {
    case 'WORKFLOWSUMMARY':
      return Object.assign({}, action.payload);
    default:
      return state;
  }
};
